import { Header } from '../../components';
const Sonekos = () => {
    return (
        <div>
            <Header title="Sonekos - Skin Booster" ></Header>
            <div className="page-section">
                <div className="container">
                    <div className="max">
                        <section id="sonekos-skin-boosters">
                            <div >
                                <h2>Sunekos Regenerative Patented Skin Booster in Cheshire</h2>
                                <p className='standardText'>
                                    Are you searching for a treatment that deeply rejuvenates, brightens, and tightens your skin from within, without changing your natural facial structure? Welcome to Sunekos®.
                                </p>
                                <p className='standardText'>
                                    SuneKOS is an injectable skin booster treatment that stimulates collagen and elastin production, improves skin hydration and texture, and reduces the appearance of wrinkles. Perfect for the face, under eye area, above lip lines, neck, decollete or hands.
                                </p>
                                 <p className='standardText'>
                                    Your skin at its best- smoother, brighter and healthier.
                                </p>
                            </div>
                        </section>
                             <section id="how-is-sonekos-different">
                            <div >
                                <h2>How is Sunekos different from other skin boosters? </h2>
                                <p className='standardText'>
                                   Rather than just containing Hyaluronic acid Sunekos contains a patented blend of Hyaluronic acid and amino acids that provide both immediate hydration  and more collagen production compared to other skin boosters on the market giving long-term structural repair, resulting in natural, long-lasting skin rejuvenation without altering facial expressions. 
                                </p>
                            </div>
                        </section>
                        <section id="how-many-sessions-will-I-need">
                            <div >
                                <h2>How many sessions will I need?</h2>
                                <p className='standardText'>
                                  Initially 3 sessions are required spaced 2 weeks apart. <br/>
                                  To maintain the results a 1 session maintenance session is recommended after 6 months. 

                                </p>
                            </div>
                        </section>

                         <section id="which-areas-can-be-treated">
                            <div >
                                <h2> Which areas can be treated?</h2>
                                <ul>
                                    <li>Face</li>
                                    <li>Under eye area</li>
                                    <li>Barcode above lip lines</li>
                                    <li>Neck</li>
                                    <li>Chest</li>
                                    <li>Hands</li>
                                </ul>
                            </div>
                        </section>

                        <section id="how-many-sessions-will-I-need">
                            <div >
                                <h2>Why is Sunekos so highly recommended for dark circles and the under eye area?</h2>
                                <p className='standardText'>
                                  The under eye area is very delicate and prone to fluid retention / puffiness. While standard tear trough filler is excellent for structural hollows, it can sometimes worsen under-eye bags or cause puffiness if the skin is very crepey. Sunekos is entirely different. Because its low-viscosity fluid does not artificially bind excess water, it is safer for the under-eye area. By stimulating new collagen creation it thickens the thin, fragile skin underneath the eyes, naturally reducing the appearance of dark circles, smoothing crepey texture, and tightening mild eye bags.

                                </p>
                            </div>
                        </section>
                            <section id="what-are-the-key-benefits-of-sunekos">
                            <div >
                                <h2>What are the key benefits of Sunekos?</h2>
                                <ul>
                                    <li>Deep long lasting hydration.</li>
                                    <li>Enhanced elastin production, improved elasticity.</li>
                                    <li>Intensified collagen production, reduced wrinkles.</li>
                                </ul>
                            </div>
                        </section>
                          <section id="when-will-i-see-results">
                            <div >
                                <h2>When will I see results?</h2>
                                <p className='standardText'>
                                    You will notice a beautiful surge of hydration soon after your first treatment. <br/>
                                    Then true structural remodelling takes time:  dermal thickening, tightening, and brightening effects usually become visibly pronounced 3 to 4 weeks after your final session, as your newly generated collagen and elastin networks mature.
                                </p>
                            </div>
                        </section>

                        <section id="what-is-the-downtime">
                            <div >
                                <h2>What is the downtime?</h2>
                                <p className='standardText'>
                                    Social downtime is  minimal,  you will leave the clinic with small, raised bumps at the injection sites.  These fluid bumps usually settle within 12 to 24 hours. <br/>
Minor pinpoint bruising may  occur.

                                </p>
                            </div>
                        </section>
                        
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Sonekos